import { getStore } from '../store/store';
import { WhatsNewCardStatus } from '../store/schema/WhatsNewCardStatus';
import { putWhatsNew } from '../services/putWhatsNew';
import { markWhatsNewCardAsRead } from '../mutators/markWhatsNewCardAsRead';
import { toggleWhatsNewCardHoverStatus } from '../mutators/toggleWhatsNewCardHoverStatus';

export async function markAllAsRead(): Promise<void> {
    let store = getStore();

    if (store.cards) {
        Object.keys(store.cards).forEach(async key => {
            toggleWhatsNewCardHoverStatus(store.cards[key], false);

            if (store.cards[key].status == WhatsNewCardStatus.Unread) {
                markWhatsNewCardAsRead(store.cards[key]);
                await putWhatsNew(store.cards[key].identity);
            }
        });
    }
}
